export default {
  name: "WrapWithPopover",
  props: {
    target: {
      type: String
    },
    click: {
      type: Boolean,
      default: false
    },
    manual: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: false
    },
    triggers: {
      type: String,
      default: "hover focus"
    },
    placement: {
      type: String,
      default: "top"
    },
    container: {
      type: String,
      default: "body"
    },
    strategy: {
      type: String,
      default: "absolute"
    },
    styles: {
      type: Object,
      default: () => ({})
    },
    width: {
      type: String
    },
    padding: {
      type: String
    },
    customClass: {
      type: String
    },
    boundary: {
      type: String
    },
    offset: {
      type: Number
    },
    delay: {
      type: Object,
      default: {
        show: 0,
        hide: 0
      }
    }
  },
  computed: {
    localShow: {
      get() {
        return this.show;
      },
      set(val) {
        // Emit an event so the parent can update the value
        this.$emit('update:show', val);
      }
    }
  }
};